import ReportList from './ReportList';
export default ReportList;



// WEBPACK FOOTER //
// ./src/scenes/Reports/components/ReportList/index.js